var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000132070421902178071640000011962556664892937625_",
    transform: "translate(-0.01 0.014)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000090282297879257623140000011817382111667616387_",
    transform: "translate(0.01 -0.014)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9448",
    d: "M24,3.3h16.4c3.7-0.2,6.8,2.7,7,6.3c0,0.2,0,0.4,0,0.6V30c0.1,3.7-2.8,6.8-6.6,6.9c-0.1,0-0.2,0-0.3,0 c-2.9,0.1-5.7-0.2-8.6,0c-0.5,0-1,0.3-1.3,0.6c-2,2.2-4.1,4.5-6.1,6.7c-0.5,0.6-0.8,0.5-1.3,0c-1.9-2.2-3.8-4.4-5.6-6.6 c-0.4-0.5-0.9-0.7-1.5-0.8c-1.4-0.1-2.8-0.1-4.2,0c-2,0.1-4.1,0.1-6.1-0.2c-3.1-0.6-5.3-3.3-5.3-6.5c0-6.8,0-13.6,0-20.3 c0-3.7,3-6.6,6.6-6.6C12.8,3.3,18.4,3.3,24,3.3z M3.4,20v9.7c-0.3,2.2,1.3,4.2,3.5,4.5c0.3,0,0.6,0,1,0c3.2,0,6.3,0,9.5,0 c0.6,0,1.1,0.2,1.4,0.7c1.5,1.8,3,3.5,4.5,5.3c0.5,0.6,0.8,0.6,1.4,0c1.6-1.8,3.2-3.5,4.8-5.3c0.4-0.4,0.9-0.7,1.5-0.6 c3.1,0,6.3,0,9.4,0c2.2,0.2,4.1-1.5,4.3-3.7c0-0.2,0-0.4,0-0.6c0-6.5,0-13,0-19.6c0.1-2.2-1.5-4.1-3.7-4.2c-0.2,0-0.4,0-0.5,0 c-10.9,0-21.8,0-32.7,0C5.5,5.9,3.5,7.6,3.4,9.8c0,0.2,0,0.4,0,0.6C3.4,13.6,3.4,16.8,3.4,20L3.4,20z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9449",
    d: "M24,17.8h13.1c0.7-0.1,1.4,0.5,1.5,1.2c0,0.3,0,0.6-0.2,0.8c-0.2,0.5-0.8,0.8-1.4,0.7H26.2 c-5.1,0-10.1,0-15.2,0C10,20.5,9.4,20,9.5,19c0.1-0.9,0.5-1.3,1.5-1.3C15.3,17.8,19.7,17.8,24,17.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9450",
    d: "M24,9.9h12.9c1.1,0,1.6,0.5,1.6,1.4c0,0.9-0.6,1.4-1.6,1.4H11.1c-1.2,0-1.8-0.7-1.6-1.8 c0.2-0.8,0.7-1,1.5-1C15.3,9.9,19.7,9.9,24,9.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_9451",
    d: "M23.9,28.4H11c-0.7,0.1-1.4-0.4-1.5-1.2c0-0.3,0-0.6,0.2-0.8c0.2-0.6,0.8-0.9,1.4-0.8h10.8 c5,0,10.1,0,15.1,0c1,0,1.4,0.4,1.5,1.2c0.1,1-0.4,1.6-1.5,1.6L23.9,28.4z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendFeedback);
export default __webpack_public_path__ + "static/media/Send Feedback.dbab7562471cd25ccfef5a29f3440f72.svg";
export { ForwardRef as ReactComponent };